import { post } from './index';
export const getToConnectionRequest = ({ filters }) =>
  post('/ToConnectionRequest', filters);
